import React, { Component } from "react";

import i18n from "i18n-react";
import PropTypes from "prop-types";

import { storageKeys } from "settings";

import {
  APIHandler,
  DataHandler,
  Diploma,
  StorageHandler,
  TrainingGrid,
  ContentHeader,
  Progress,
  PrintComponent,
} from "C4";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters
      .filter((chapter) => !!chapter.specialization === false)
      .forEach((chapter) => {
        totalPages += chapter.total_pages - 1;
      });
  }
  return totalPages;
};

// Makes sure progress is returned in percentage value
const calculateProgress = (progress, pages) =>
  Math.floor((progress / pages) * 100);

const getTotalProgress = (res) => {
  let totalProgress = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters
      .filter((chapter) => !!chapter.specialization === false)
      .forEach((chapter) => {
        totalProgress += chapter.progress;
      });
  }
  return totalProgress;
};

const ViewDiploma = ({ diploma }) => {
  if (diploma !== 100) return null;

  const hasViewedDiploma = localStorage.getItem("hasViewedDiploma");
  if (hasViewedDiploma) return null;

  localStorage.setItem("hasViewedDiploma", true);
  setTimeout(() => {
    document.getElementById("showDiplomaButton").click();
  }, 2000);

  return null;
};

// Calculates whether the diploma has been earned
const diplomaEarned = (userProgress, chaptersToComplete) => {
  for (let i = 0; i < chaptersToComplete; i += 1) {
    if (
      userProgress.data[0].chapters[i].progress !==
      userProgress.data[0].chapters[i].total_pages
    ) {
      return false;
    }
  }
  return true;
};

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      firstName: "Firstname",
      lastName: "Lastname",
      chapterCountDiploma: 8,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getUserInfo();
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue } = this.state;
    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    if (diploma >= 100) {
      const d = new Date(Date.now());
      const leading = (val) => `0${val}`.slice(-2);
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user.training_graduated === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(
            d.getMonth() + 1
          )}-${leading(d.getDate())}`;
          DataHandler.matchAppId().then((appId) => {
            APIHandler.updateUser(appId, obj.email, [
              { param: "sales_companion_registered", val: date },
              { param: "training_started", val: date },
              { param: "training_graduated", val: date },
            ]).then((res) => {
              if (res && obj) {
                obj.sales_companion_registered = date;
                obj.training_started = date;
                obj.training_graduated = date;

                StorageHandler.save(storageKeys.user, obj);
              }
            });
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getUserInfo() {
    const { chapterCountDiploma } = this.state;
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.getUserProgress(appId, email).then((userProgress) => {
            const totalProgress = getTotalProgress(userProgress);
            const totalPages = getTotalPages(userProgress);
            const percentage = calculateProgress(totalProgress, totalPages);
            this.setState({
              totalProgressValue: percentage >= 100 ? 100 : percentage,
            });
            if (diplomaEarned(userProgress, chapterCountDiploma)) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });
          StorageHandler.load(storageKeys.user).then((user) => {
            const { first_name: firstName, last_name: lastName } = user;
            this.setState({ firstName, lastName, appId });
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  render() {
    const { diploma, firstName, lastName, totalProgressValue, appId } =
      this.state;

    return (
      <div className="contentContainer trainingView">
        <ContentHeader
          header={i18n.translate("contentHeaders.train")}
          subtitle={i18n.translate("pageDescriptions.train")}
          line={false}
        >
          <div className="container__Progress">
            <div className="container__progressBar">
              <Progress id="progress" value={totalProgressValue} />
              <span>
                {totalProgressValue}
                {i18n.translate("trainingScreens.percentageComplete")}{" "}
              </span>
            </div>
            <a
              id="showDiplomaButton" // id used for simulating click
              className={`container__progressDiploma ${
                totalProgressValue === 100 ? "completed" : ""
              }`}
              role="button"
              tabIndex={-1}
              data-fancybox
              data-src="#diploma"
              data-options='{"toolbar" : "true", "buttons" : ["close"]}'
              href="javascript:;"
              style={{ pointerEvents: diploma === 100 ? "auto" : "none" }}
            >
              <FontAwesomeIcon
                icon={["far", "file-certificate"]}
                className={`far fa-file-certificate ${
                  diploma === 100 ? "completed" : ""
                }`}
              />
              <p className="text__viewDiploma">
                {diploma === 100 && i18n.translate("nav.reportCard")}
              </p>
            </a>
            <style>
              {
                "\
            #openWidget { display: block; bottom: 4rem; } "
              }
            </style>
          </div>
        </ContentHeader>
        <TrainingGrid />
        {diploma === 100 && (
          <React.Fragment>
            <Diploma appId={appId} firstName={firstName} lastName={lastName} />
            <ViewDiploma diploma={diploma} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  firstName: "",
  lastName: "",
};
